import React from 'react';

import {DelayRender} from './DelayRender';
import {
  type CappedPanelInputs,
  useCappedPanelOptIn,
} from './useCappedPanelOptIn';

/**
 * The Delay Render warning, driven by the capped-panel slice. The slice
 * records that the warning was shown, so it runs here, where the warning
 * mounts (rule 12).
 */
export function CappedPanelDelayRender(props: CappedPanelInputs) {
  const {onLoadAnyway} = useCappedPanelOptIn(props);

  return <DelayRender onLoadAnyway={onLoadAnyway} />;
}
